<div
  class="tooltip"
  [ngStyle]="{ top: position?.top, left: position?.left }"
  [ngClass]="{ 'tooltip--visible': isVisible }"
>
  {{ text }}
</div>
